import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AppearenceRoutingModule } from './appearence-routing.module';
import { LeaveComponent } from './leave/leave.component';
import { PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { HighchartsChartModule } from 'highcharts-angular';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from 'src/app/shared/shared.module';
import { RegularComponent } from './regular/regular.component';
import { AbsenceListComponent } from './absence/absence-list/absence-list.component';
import { AbsenceCrudComponent } from './absence/absence-crud/absence-crud.component';
import { ManageLeaveComponent } from './leave/manage-leave/manage-leave.component';
import { LeaveApprovalComponent } from './leave/leave-approval/leave-approval.component';
import { LeavesComponent } from './leave/leaves/leaves.component';
import { ManageRegularComponent } from './regular/manage-regular/manage-regular.component';
import { RegularListComponent } from './regular/regular-list/regular-list.component';
import { RegularApprovalComponent } from './regular/regular-approval/regular-approval.component';
import { VacayComponent } from './vacay/vacay.component';


@NgModule({
  declarations: [
    LeaveComponent,
    RegularComponent,
    AbsenceListComponent,
    AbsenceCrudComponent,
    ManageLeaveComponent,
    LeaveApprovalComponent,
    LeavesComponent,
    ManageRegularComponent,
    RegularListComponent,
    RegularApprovalComponent,
    VacayComponent
  ],
  imports: [
    CommonModule,
    AppearenceRoutingModule,
    PerfectScrollbarModule,
    HighchartsChartModule,
    FormsModule,
    ReactiveFormsModule,
    SharedModule
  ]
})
export class AppearenceModule { }
